<h1 class="h1 text_algn text-center" style="color:#0064A5;">Branch Change Portal</h1>
<p class="lead text_algn text-center">Change Your Home Branch Here.</p>
<div class="container">
  <div class="col-lg-12">
    <div class="row">
      <div class="offset-lg-3 col-lg-6">
        <div class="card mt-8">
          <div class="card-header cheader">
            Account Details
          </div>
          <div class="card-body">
            <div class="form-horizontal">
                <!-- Text input-->
                <div class="form-group">                  
                  <div class="col-md-12">
                    <input [(ngModel)]="account_number" id="textinput" name="textinput"
                    (ngModelChange)="disableGenerateButton()" 
                    type="text" placeholder="Enter Account Number Here"
                      class="form-control input-md" knifeOnlyNumbers autocomplete="off" maxlength="14">
                  </div>
                </div>

                <!-- Password input-->
                <div class="form-group">                 
                  <div class="col-md-12">
                    <input  [(ngModel)]="txtcaptcha" id="captcha" name="passwordinput"
                    (ngModelChange)="disableGenerateButton()"
                     type="text" placeholder="Enter Captcha Here"
                      class="form-control input-md" autocomplete="off">
                      <div style="margin-top: 7px;"><img alt="Unable to Load Captcha" src={{captchaimg}} width="155px">
                        <span style="padding-left: 15px;"><span class="text-primary" style="cursor: pointer;" (click)="captchatoimage()">Refresh Captcha</span></span>
                        <div *ngIf="isVisible" class="text-danger">** Invalid Captcha</div>
                      </div>
                  </div>
                </div>

                <!-- submit button -->
                <div class="form-group ">
                  <!-- <label class="col-md-12 control-label" for="passwordinput">Password Input</label> -->
                  <div class="col-md-12 ">
                    <button (click)="GETOTP()" [disabled]="isDisabled" class="btn btn-info btn-block">Submit</button>
                  </div>
                  <div class="col-md-12" style="margin-top: 10px;">
                    <div *ngIf="OTPresponseVisible" class="text-danger">** {{OTPresponse}}</div>
                  </div>
                </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">  
  <p style="color: white">Please Wait. </p>  
  </ngx-spinner>